<div class="form-group" [formGroup]="form">
    <label> {{ field['label'] }} </label>
    <textarea class="form-control" rows="5" cols="30" id="float-area" [value]="field['value']"
        [formControlName]="field['name']" pInputTextarea placeholder="{{ field['label'] }}"></textarea>
</div>